import React, { FunctionComponent } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { colours } from "@/utils/themeUtils";

const ErrorFallback: FunctionComponent = (): JSX.Element => {
	return (
		<Flex justifyContent={"space-between"}>
			<Box></Box>
			<Box
				display={"inline-block"}
				alignItems={"center"}
				borderRadius="lg"
				p={4}
				px={5}
				backgroundColor={colours.danger.background.weaker}
				my={5}
				border="1px solid"
				borderColor={colours.danger.background.medium}
				boxShadow="sm"
			>
				<Text fontFamily="Poppins" fontSize="sm" fontWeight="medium" role="heading" textAlign={"center"} color={colours.danger.icon}>
					Error loading Courses module. Please refresh the page and try again.
				</Text>
			</Box>
			<Box></Box>
		</Flex>
	);
};

export default ErrorFallback;
